<div class="merge-account-holder">
    <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
    <div class="title-holder">
        <h2 *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.merge_account_title ? moduleAuthTexts.merge_account_title : 'Set up your account.'}}</h2>
        <p class="desc" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.merge_account_description ? moduleAuthTexts.merge_account_description : 'Please enter a password to set up your online account and access your booking information.'}}</p>
        <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
            {{ formErrorMessage }}
        </serviceos-ng-alert>
        <serviceos-ng-alert class="error-alert" *ngIf="!isRepeatPasswordMatch" [type]="'error'">
            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                {{ moduleAuthTexts.passwords_do_not_match_error ? moduleAuthTexts.passwords_do_not_match_error : 'The passwords do not match!' }}
            </ng-container>
        </serviceos-ng-alert>
    </div>
    <form
        [formGroup]="mergeAccountForm"
        (ngSubmit)="processForm()"
        #mergeAccountFormTemplate="ngForm"
    >
        <div class="obf-form-part">
            <div class="input-holder">
                <serviceos-ng-form-field>
                    <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_pass_title ? moduleAuthTexts.recover_pass_title : 'Please enter your password' }}</serviceos-ng-label>
                    <input
                        [serviceosNgInput]="password?.value"
                        [error]="
                        password?.invalid && mergeAccountFormTemplate.submitted
                        "
                        type="password"
                        id="password"
                        name="password"
                        formControlName="password"
                    />
                    <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_pass_error ? moduleAuthTexts.recover_pass_error : 'Please enter a valid password' }}</serviceos-ng-error-message>
                </serviceos-ng-form-field>
            </div>
            <div class="input-holder">
                <serviceos-ng-form-field>
                    <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_repeat_pass_title ? moduleAuthTexts.recover_repeat_pass_title : 'Repeat your password' }}</serviceos-ng-label>
                    <input
                        [serviceosNgInput]="repeat_password?.value"
                        [error]="
                        repeat_password?.invalid && mergeAccountFormTemplate.submitted
                        "
                        type="password"
                        id="repeat_password"
                        name="repeat_password"
                        formControlName="repeat_password"
                    />
                    <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_repeat_pass_error ? moduleAuthTexts.recover_repeat_pass_error : 'Please enter a valid password' }}</serviceos-ng-error-message>
                </serviceos-ng-form-field>
            </div>

            <div>
                <serviceos-ng-button
                    [isSubmitButton]="true"
                    [type]="'primary'"
                    [isFullWidth]="true"
                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                    >
                    {{ moduleAuthTexts.merge_account_button ? moduleAuthTexts.merge_account_button : 'Continue to your account' }}
                </serviceos-ng-button>
            </div>
        </div>
    </form>
</div>
